import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../ui/Primitives.jsx';
import { fillTemplate } from '../../lib/helpers.js';

// Modal de upsell disparado na 1ª tentativa de fechar o paywall. O contador
// é real (não decorativo): quando chega a 0, o desconto realmente some (o
// botão passa a levar de volta pro paywall padrão) — nunca fingimos urgência
// que não existe, é um dos pontos que a Gladis pediu pra evitar em relação
// aos truques de venda que incomodam usuárias da concorrência.
export default function UpsellModal({ step, onAccept, onClose }) {
  const [secondsLeft, setSecondsLeft] = useState(step.countdownSeconds);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const t = setInterval(() => setSecondsLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [secondsLeft]);

  const expired = secondsLeft <= 0;
  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const ss = String(secondsLeft % 60).padStart(2, '0');

  return (
    <div className="fixed inset-0 bg-bg/80 backdrop-blur-sm flex items-end justify-center z-50">
      <div className="phone-frame w-full bg-surface rounded-t-3xl p-6 relative">
        <button onClick={onClose} aria-label="Fechar" className="absolute top-4 right-4 w-8 h-8 rounded-full bg-surface-2 flex items-center justify-center">
          ✕
        </button>
        <h2 className="font-display text-2xl font-extrabold mb-2 pr-8">{step.headline}</h2>
        <p className="text-ink-muted mb-6">{step.subtitle}</p>

        {!expired ? (
          <div className="flex justify-center gap-2 mb-6">
            {[mm[0], mm[1], ':', ss[0], ss[1]].map((c, i) =>
              c === ':' ? (
                <span key={i} className="text-2xl font-bold self-center">:</span>
              ) : (
                <span key={i} className="bg-surface-2 rounded-lg w-10 h-12 flex items-center justify-center font-display text-xl font-bold">
                  {c}
                </span>
              )
            )}
          </div>
        ) : (
          <p className="text-center text-danger text-sm mb-6">Essa oferta expirou, mas você ainda pode assinar no preço padrão.</p>
        )}

        <PrimaryButton onClick={() => onAccept(expired)} className={expired ? '' : 'shadow-glow'}>
          {step.cta}
        </PrimaryButton>

        {!expired && (
          <p className="text-center text-sm text-ink mt-4">
            {fillTemplate(step.billingDisclosureTemplate, { precoTotal: step.priceTotalLabel ?? 'R$ 0,00', precoMes: step.priceMonthlyLabel ?? 'R$ 0,00' })}
          </p>
        )}
      </div>
    </div>
  );
}
